import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { initializeThirdParty } from './app.initializer';
import { appRoutes } from './app.routes';
import { GlobalErrorHandlerService } from './global-error-handler.service';
import { HttpInterceptorService } from './http-interceptor.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(appRoutes, withComponentInputBinding()),
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true,
        },
        provideAppInitializer(() => {
            const initializerFn = initializeThirdParty(inject(HttpClient));
            return initializerFn();
        }),
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    ],
};
